import { RSAA, getJSON } from 'redux-api-middleware';
import { getPayload } from '../../utils';
import {
  ANALYTICS_ERROR,
  ROUTE_SIGNIFICANT_PEOPLE_PAGE,
  DEFAULT_BANK,
  PRIMARY_BANK_ID,
  ROUTE_INFORMATIVE_PAGE
} from '../../utils/constants';
import * as analytics from '../../utils/analytics';
import {
  dispatchNextAction,
  getFileName,
  isFetchCaseRequired,
  processGetCustomer,
  updateBankStyle,
  isResumeCase
} from './action.helper';

import { technicalErrorPage, redirectToPage } from '../../store/dataCapture/actions';
import { setSecondaryApplicantNTB } from '../../utils';

export const DOWNLOAD_LIST_LOCATOR = 'DOWNLOAD_LIST_LOCATOR';
export const DOWNLOAD_LIST_LOCATOR_SUCCESS = 'DOWNLOAD_LIST_LOCATOR_SUCCESS';
export const DOWNLOAD_LIST_LOCATOR_FAILED = 'DOWNLOAD_LIST_LOCATOR_FAILED';

export const DOWNLOAD_PDF_LIST = 'DOWNLOAD_PDF_LIST';
export const DOWNLOAD_PDF_LIST_SUCCESS = 'DOWNLOAD_PDF_LIST_SUCCESS';
export const DOWNLOAD_PDF_LIST_FAILED = 'DOWNLOAD_PDF_LIST_FAILED';
export const FETCH_CONFIG = 'FETCH_CONFIG';
export const FETCH_CONFIG_SUCCESS = 'FETCH_CONFIG_SUCCESS';
export const FETCH_CONFIG_FAILED = 'FETCH_CONFIG_FAILED';
export const REQUEST_TOKEN = 'REQUEST_TOKEN';
export const REQUEST_TOKEN_SUCCESS = 'REQUEST_TOKEN_SUCCESS';
export const REQUEST_TOKEN_FAILED = 'REQUEST_TOKEN_FAILED';
export const CSS_LOADING = 'CSS_LOADING';
export const REDIRECT_TO_SIGNIFICANT_PAGE = 'REDIRECT_TO_SIGNIFICANT_PAGE';
export const SET_RESUME_PARAM = 'SET_RESUME_PARAM';
export const RESET_SECONDARY_EXISTING_NTB = 'RESET_SECONDARY_EXISTING_NTB';

export const updateCSSLoading = isLoaded => {
  return {
    type: CSS_LOADING,
    isCssLoaded: true
  };
};

export const fetchConfig = (configPath = './config.json') => ({
  [RSAA]: {
    endpoint: configPath,
    method: 'GET',
    types: [
      {
        type: FETCH_CONFIG,
        meta: {
          loading: true
        }
      },
      {
        type: FETCH_CONFIG_SUCCESS,
        payload: (action, state, res) => getPayload(action, state, res),
        meta: (_action, state, res) => ({
          nextAction: dispatchNextAction(state, res.json.staticProductContentUrl),
          loading: true
        })
      },
      {
        type: FETCH_CONFIG_FAILED,
        meta: () => {
          analytics.error({
            errorCode: 0,
            errorMessage: ANALYTICS_ERROR.FETCH_CONFIG_FAILED
          });
          return {
            loading: false
          };
        }
      }
    ]
  }
});

export const downloadListLocator = (ihsUrl, isLoder) => ({
  [RSAA]: {
    endpoint: `${ihsUrl}/config/document-list-locator.json`,
    method: 'GET',
    types: [
      {
        type: DOWNLOAD_LIST_LOCATOR,
        meta: {
          loading: true
        }
      },
      {
        type: DOWNLOAD_LIST_LOCATOR_SUCCESS,
        payload: (action, state, res) => getPayload(action, state, res),
        meta: (_action, _state, res) => ({
          nextAction: getDownloadPdf(ihsUrl, getFileName(res.json.doc_lists), isLoder),
          loading: isLoder
        })
      },
      {
        type: DOWNLOAD_LIST_LOCATOR_FAILED,
        meta: {
          loading: false
        }
      }
    ]
  }
});

export const getDownloadPdf = (ihsUrl, res, isLoder) => ({
  [RSAA]: {
    endpoint: `${ihsUrl}/config/${res.length > 0 ? res[0].file_name : ''}`,
    method: 'GET',
    types: [
      {
        type: DOWNLOAD_PDF_LIST,
        meta: {
          loading: true
        }
      },
      {
        type: DOWNLOAD_PDF_LIST_SUCCESS,
        payload: (action, state, res) => getPayload(action, state, res),
        meta: {
          loading: isLoder
        }
      },
      {
        type: DOWNLOAD_PDF_LIST_FAILED,
        meta: {
          loading: false
        }
      }
    ]
  }
});

export const getToken = () => ({
  [RSAA]: {
    endpoint: `:api_paas_url/user/token`,
    method: 'GET',
    headers: {
      'x-bpi-service-context': 'USER',
      'x-bpi-version': '0.8.0'
    },
    types: [
      {
        type: REQUEST_TOKEN,
        meta: {
          loading: true
        }
      },
      {
        type: REQUEST_TOKEN_SUCCESS,
        payload: (_action, _state, res) =>
          getJSON(res).then(json => {
            res.json = json;
            return json;
          }),
        meta: (_action, state, res) => ({
          nextAction: dispatch => {
            const primaryBankId = state.config.get(PRIMARY_BANK_ID);
            if (primaryBankId && primaryBankId !== res.json.bank_id) {
              //clear token, set primary  bankId
              dispatch(redirectToPage(ROUTE_INFORMATIVE_PAGE));
              dispatch(resetSecondaryToNTB(primaryBankId));
              setSecondaryApplicantNTB();
            } else {
              isFetchCaseRequired(state, dispatch);
              processGetCustomer(dispatch);
              updateBankStyle(res.json.bank_id, dispatch);
              isResumeCase(state, dispatch);
            }
          },
          loading: false
        })
      },
      {
        type: REQUEST_TOKEN_FAILED,
        meta: () => {
          analytics.error({
            errorCode: 0,
            errorMessage: ANALYTICS_ERROR.REQUEST_TOKEN_FAILED
          });
          return {
            nextAction: dispatch => {
              updateBankStyle(DEFAULT_BANK, dispatch);
              dispatch(technicalErrorPage());
            },
            loading: false
          };
        }
      }
    ]
  }
});

export const redirectToSignificantPeoplePage = applicantFlow => ({
  type: REDIRECT_TO_SIGNIFICANT_PAGE,
  data: applicantFlow ? applicantFlow : '',
  path: ROUTE_SIGNIFICANT_PEOPLE_PAGE
});

export const setResumeConfigParam = resumeParam => ({
  type: SET_RESUME_PARAM,
  data: resumeParam
});

const resetSecondaryToNTB = bankId => ({
  type: RESET_SECONDARY_EXISTING_NTB,
  data: bankId
});
